export default __webpack_public_path__ + "static/media/@deludovico.db3970ce.jpg";